import React, { useState } from 'react';
import { useLocation } from '../../context/LocationContext';
import './countrySelector.styles.scss';

/**
 * Beautiful country selector dropdown component
 * Allows users to manually select which country's products to view
 */
export default function CountrySelector() {
    const { userCountry, setUserCountry, loading } = useLocation();
    const [isOpen, setIsOpen] = useState(false);

    const countries = [
        { code: 'mx', name: 'México', flag: '🇲🇽' },
        { code: 'us', name: 'Estados Unidos', flag: '🇺🇸' },
        { code: 'global', name: 'Global', flag: '🌍' }
    ];

    const currentCountry = countries.find(country => country.code === userCountry) || countries[2]; // Default to global

    const handleCountryChange = (countryCode) => {
        setUserCountry(countryCode);
        setIsOpen(false);
        // Remove localStorage - let context handle everything
    };

    if (loading) {
        return (
            <div className="country-selector__loading">
                🔍 Detectando...
            </div>
        );
    }

    return (
        <div className="country-selector">
            {/* Dropdown Button */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`country-selector__button ${loading ? 'country-selector__button--loading' : ''}`}
                disabled={loading}
            >
                <span className="country-selector__flag">{currentCountry.flag}</span>
                <span className="country-selector__name">{currentCountry.name}</span>
                <span className={`country-selector__arrow ${isOpen ? 'country-selector__arrow--open' : ''}`}>
                    ▼
                </span>
            </button>

            {/* Dropdown Menu */}
            {isOpen && (
                <div className="country-selector__dropdown">
                    {countries.map((country) => (
                        <button
                            key={country.code}
                            onClick={() => handleCountryChange(country.code)}
                            className={`country-selector__option ${userCountry === country.code ? 'country-selector__option--selected' : ''}`}
                        >
                            <span className="country-selector__option-flag">{country.flag}</span>
                            <span className="country-selector__option-name">{country.name}</span>
                            {userCountry === country.code && (
                                <span className="country-selector__check">✓</span>
                            )}
                        </button>
                    ))}
                </div>
            )}

            {/* Click outside to close */}
            {isOpen && (
                <div
                    className="country-selector__overlay"
                    onClick={() => setIsOpen(false)}
                />
            )}
        </div>
    );
}
